var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.report.summary ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var hover = _ref.hover;
        return [_c('v-card', {
          staticClass: "mx-auto",
          attrs: {
            "flat": ""
          }
        }, [_c('v-card-text', [_c('v-icon', {
          attrs: {
            "left": "",
            "color": "primary"
          }
        }, [_vm._v(" mdi-creation ")]), _vm._v(" " + _vm._s(_vm.report.summary) + " "), hover ? _c('v-fab-transition', [_c('v-btn', {
          attrs: {
            "elevation": "0",
            "absolute": "",
            "fab": "",
            "bottom": "",
            "right": "",
            "x-small": ""
          },
          on: {
            "click": function click($event) {
              return _vm.thumbs(false);
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "color": "primary"
          }
        }, [_vm._v("mdi-thumb-down-outline")])], 1)], 1) : _vm._e(), hover ? _c('v-fab-transition', [_c('v-btn', {
          staticClass: "mr-8",
          attrs: {
            "elevation": "0",
            "absolute": "",
            "fab": "",
            "bottom": "",
            "right": "",
            "x-small": ""
          },
          on: {
            "click": function click($event) {
              return _vm.thumbs(true);
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "color": "primary"
          }
        }, [_vm._v("mdi-thumb-up-outline")])], 1)], 1) : _vm._e()], 1)], 1)];
      }
    }], null, false, 473895278)
  })], 1)], 1) : _vm._e(), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.damage.references")) + " "), _c('v-spacer'), _c('m-icon-button', {
    on: {
      "click": function click($event) {
        _vm.isReferencesDialogOpen = true;
      }
    }
  })], 1), _c('v-card-text', [_c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_vm.report.broker ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3",
      "lg": "2"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.report.broker.name'),
      "readonly": _vm.readonly,
      "hide-details": ""
    },
    model: {
      value: _vm.report.broker.name,
      callback: function callback($$v) {
        _vm.$set(_vm.report.broker, "name", $$v);
      },
      expression: "report.broker.name"
    }
  }), _c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.report.broker.number'),
      "readonly": _vm.readonly,
      "hide-details": ""
    },
    model: {
      value: _vm.report.broker.number,
      callback: function callback($$v) {
        _vm.$set(_vm.report.broker, "number", $$v);
      },
      expression: "report.broker.number"
    }
  })], 1) : _vm._e(), _vm.report.attorney ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3",
      "lg": "2"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.report.attorney.name'),
      "readonly": _vm.readonly,
      "hide-details": ""
    },
    model: {
      value: _vm.report.attorney.name,
      callback: function callback($$v) {
        _vm.$set(_vm.report.attorney, "name", $$v);
      },
      expression: "report.attorney.name"
    }
  }), _c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.report.attorney.number'),
      "readonly": _vm.readonly,
      "hide-details": ""
    },
    model: {
      value: _vm.report.attorney.number,
      callback: function callback($$v) {
        _vm.$set(_vm.report.attorney, "number", $$v);
      },
      expression: "report.attorney.number"
    }
  })], 1) : _vm._e(), _vm._l(_vm.report.insurances, function (insurance, index) {
    return _c('v-col', {
      key: "insurance-".concat(index),
      attrs: {
        "cols": "12",
        "md": "3",
        "lg": "2"
      }
    }, [_c('m-text-field', {
      attrs: {
        "label": _vm.$t('objects.report.insurances.name'),
        "readonly": _vm.readonly,
        "hide-details": ""
      },
      model: {
        value: insurance.name,
        callback: function callback($$v) {
          _vm.$set(insurance, "name", $$v);
        },
        expression: "insurance.name"
      }
    }), _c('m-text-field', {
      attrs: {
        "label": _vm.$t('objects.report.insurances.number'),
        "readonly": _vm.readonly,
        "hide-details": ""
      },
      model: {
        value: insurance.number,
        callback: function callback($$v) {
          _vm.$set(insurance, "number", $$v);
        },
        expression: "insurance.number"
      }
    })], 1);
  }), _vm.report.leasing ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3",
      "lg": "2"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.report.leasing.company'),
      "readonly": _vm.readonly,
      "hide-details": ""
    },
    model: {
      value: _vm.report.leasing.company,
      callback: function callback($$v) {
        _vm.$set(_vm.report.leasing, "company", $$v);
      },
      expression: "report.leasing.company"
    }
  }), _c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.report.leasing.claimNumber'),
      "readonly": _vm.readonly,
      "hide-details": ""
    },
    model: {
      value: _vm.report.leasing.claimNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.report.leasing, "claimNumber", $$v);
      },
      expression: "report.leasing.claimNumber"
    }
  })], 1) : _vm._e(), _vm.report.policeDetails ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3",
      "lg": "2"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.report.policeDetails.department'),
      "readonly": _vm.readonly,
      "hide-details": ""
    },
    model: {
      value: _vm.report.policeDetails.department,
      callback: function callback($$v) {
        _vm.$set(_vm.report.policeDetails, "department", $$v);
      },
      expression: "report.policeDetails.department"
    }
  }), _c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.report.policeDetails.fileReference'),
      "readonly": _vm.readonly,
      "hide-details": ""
    },
    model: {
      value: _vm.report.policeDetails.fileReference,
      callback: function callback($$v) {
        _vm.$set(_vm.report.policeDetails, "fileReference", $$v);
      },
      expression: "report.policeDetails.fileReference"
    }
  })], 1) : _vm._e()], 2), _vm.thirdPartySystems.length > 0 ? _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.thirdPartySystems, function (tps, index) {
    return _c('v-col', {
      key: "tps-".concat(index),
      attrs: {
        "cols": "12",
        "md": "3",
        "lg": "2"
      }
    }, [_c('m-text-field', {
      attrs: {
        "label": tps.system,
        "readonly": true,
        "hide-details": ""
      },
      model: {
        value: tps.externalId,
        callback: function callback($$v) {
          _vm.$set(tps, "externalId", $$v);
        },
        expression: "tps.externalId"
      }
    })], 1);
  }), 1) : _vm._e()], 1)], 1)], 1)], 1), _c('v-divider'), _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    staticClass: "order-md-last",
    attrs: {
      "cols": "12",
      "md": "7",
      "lg": "8"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("common.nouns.damage")) + " "), _c('v-spacer'), _c('m-icon-button', {
    on: {
      "click": function click($event) {
        _vm.isEditDamageDialogOpen = true;
      }
    }
  })], 1), _c('v-card-text', [_c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "6",
      "lg": "3"
    }
  }, [_c('m-select', {
    attrs: {
      "label": _vm.$t('objects.report.damageType'),
      "readonly": _vm.readonly,
      "items": _vm.damageTypeItems,
      "append-icon": _vm.readonly ? '' : undefined,
      "hide-details": ""
    },
    model: {
      value: _vm.report.damageType,
      callback: function callback($$v) {
        _vm.$set(_vm.report, "damageType", $$v);
      },
      expression: "report.damageType"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "6",
      "lg": "3"
    }
  }, [_c('m-select', {
    attrs: {
      "label": _vm.$t('objects.report.coverageType'),
      "readonly": _vm.readonly,
      "items": _vm.coverageTypeItems,
      "append-icon": _vm.readonly ? '' : undefined,
      "hide-details": ""
    },
    model: {
      value: _vm.report.coverageType,
      callback: function callback($$v) {
        _vm.$set(_vm.report, "coverageType", $$v);
      },
      expression: "report.coverageType"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "6",
      "lg": "3"
    }
  }, [_c('m-select', {
    attrs: {
      "label": _vm.$t('objects.report.isDrivable'),
      "readonly": _vm.readonly,
      "items": [true, false],
      "append-icon": _vm.readonly ? '' : undefined,
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('v-chip', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("".concat(item ? "yes" : "no"))) + " ")])];
      }
    }, {
      key: "item",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(_vm.$t("".concat(item ? "yes" : "no"))) + " ")];
      }
    }]),
    model: {
      value: _vm.report.isDrivable,
      callback: function callback($$v) {
        _vm.$set(_vm.report, "isDrivable", $$v);
      },
      expression: "report.isDrivable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "6",
      "lg": "3"
    }
  }, [_c('m-select', {
    attrs: {
      "label": _vm.$t('objects.report.isRoadworthy'),
      "readonly": _vm.readonly,
      "items": [true, false],
      "append-icon": _vm.readonly ? '' : undefined,
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c('v-chip', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("".concat(item ? "yes" : "no"))) + " ")])];
      }
    }, {
      key: "item",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_vm._v(" " + _vm._s(_vm.$t("".concat(item ? "yes" : "no"))) + " ")];
      }
    }]),
    model: {
      value: _vm.report.isRoadworthy,
      callback: function callback($$v) {
        _vm.$set(_vm.report, "isRoadworthy", $$v);
      },
      expression: "report.isRoadworthy"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "6",
      "lg": "3"
    }
  }, [_c('m-select', {
    attrs: {
      "label": _vm.$t('objects.report.isWrapped'),
      "readonly": _vm.readonly,
      "items": [true, false],
      "append-icon": _vm.readonly ? '' : undefined,
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_c('v-chip', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("".concat(item ? "yes" : "no"))) + " ")])];
      }
    }, {
      key: "item",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [_vm._v(" " + _vm._s(_vm.$t("".concat(item ? "yes" : "no"))) + " ")];
      }
    }]),
    model: {
      value: _vm.report.isWrapped,
      callback: function callback($$v) {
        _vm.$set(_vm.report, "isWrapped", $$v);
      },
      expression: "report.isWrapped"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "6",
      "lg": "3"
    }
  }, [_c('m-select', {
    attrs: {
      "label": _vm.$t('objects.report.isWrapDamaged'),
      "readonly": _vm.readonly,
      "items": [true, false],
      "append-icon": _vm.readonly ? '' : undefined,
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return [_c('v-chip', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("".concat(item ? "yes" : "no"))) + " ")])];
      }
    }, {
      key: "item",
      fn: function fn(_ref9) {
        var item = _ref9.item;
        return [_vm._v(" " + _vm._s(_vm.$t("".concat(item ? "yes" : "no"))) + " ")];
      }
    }]),
    model: {
      value: _vm.report.isWrapDamaged,
      callback: function callback($$v) {
        _vm.$set(_vm.report, "isWrapDamaged", $$v);
      },
      expression: "report.isWrapDamaged"
    }
  })], 1), _vm.report.totalLoss ? _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "6",
      "lg": "3"
    }
  }, [_c('m-select', {
    attrs: {
      "label": _vm.$t('objects.report.totalLoss'),
      "readonly": _vm.readonly,
      "items": Object.values(_vm.TotalLossType),
      "append-icon": _vm.readonly ? '' : undefined,
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref10) {
        var item = _ref10.item;
        return [_vm._v(" " + _vm._s(_vm.$t("enums.TotalLossType.".concat(item))) + " ")];
      }
    }, {
      key: "item",
      fn: function fn(_ref11) {
        var item = _ref11.item;
        return [_vm._v(" " + _vm._s(_vm.$t("enums.TotalLossType.".concat(item))) + " ")];
      }
    }], null, false, 4246015100),
    model: {
      value: _vm.report.totalLoss,
      callback: function callback($$v) {
        _vm.$set(_vm.report, "totalLoss", $$v);
      },
      expression: "report.totalLoss"
    }
  })], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.$t('common.nouns.description'),
      "readonly": _vm.readonly,
      "hide-details": "",
      "rows": "3"
    },
    model: {
      value: _vm.report.message,
      callback: function callback($$v) {
        _vm.$set(_vm.report, "message", $$v);
      },
      expression: "report.message"
    }
  })], 1)], 1), _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "lg": "4"
    }
  }, [_c('v-subheader', {
    staticClass: "px-0"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.partner.PartnerReportDetailInfoCard.damageLocator.title")) + " ")]), _c('div', {
    staticClass: "mx-auto d-flex justify-center align-center",
    staticStyle: {
      "max-width": "300px"
    }
  }, [_c('damage-locator-combined', {
    key: "damage-locator-".concat(_vm.report.id, "-").concat(_vm.damageKey),
    ref: "DamageLocator",
    attrs: {
      "isEdit": false,
      "reportType": _vm.report.reportType,
      "damage-locations": _vm.report.damage
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "lg": "8"
    },
    on: {
      "dragover": function dragover($event) {
        $event.preventDefault();
        return _vm.startDrag.apply(null, arguments);
      }
    }
  }, [_c('v-subheader', {
    staticClass: "px-0"
  }, [_vm._v(" " + _vm._s(_vm.$t("common.nouns.images")) + " "), _c('v-spacer'), _vm.report.attachment && _vm.report.attachment.length ? _c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.reportRequestInformationDialog.open();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-open-in-new")]), _vm._v(" " + _vm._s(_vm.$t("common.verbs.request")) + " ")], 1) : _vm._e(), _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-download-outline",
      "loading": _vm.isDownloadImage
    },
    on: {
      "click": _vm.startDownload
    }
  }), _c('m-icon-button', {
    attrs: {
      "icon": "mdi-plus"
    },
    on: {
      "click": function click($event) {
        _vm.isImageUploadDialogOpen = true;
      }
    }
  })], 1), _vm.isDrag ? _c('div', {
    staticStyle: {
      "height": "calc(100% - 48px)",
      "width": "100%",
      "background-color": "rgba(200,200,200,0.5)"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    },
    on: {
      "dragleave": function dragleave($event) {
        $event.preventDefault();
        return _vm.endDrag.apply(null, arguments);
      },
      "drop": function drop($event) {
        $event.preventDefault();
        return _vm.onFileDrop($event);
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "transform": "scale(300%)"
    },
    attrs: {
      "x-large": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.prependIcon) + " ")]), _c('span', {
    staticClass: "pl-8"
  }, [_vm._v(" " + _vm._s(_vm.$t("cost.dragAndDropDocuments")) + " ")])], 1)]) : !_vm.report.attachment || !_vm.report.attachment.length ? _c('m-no-content', {
    attrs: {
      "icon": "mdi-camera-off",
      "text": _vm.$t('components.PartnerReportDetail.damage.missingImages')
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex flex-column flex-sm-row"
        }, [_c('v-btn', {
          staticClass: "mb-2 mb-sm-0 mr-sm-2",
          attrs: {
            "outlined": ""
          },
          on: {
            "click": function click($event) {
              return _vm.$refs.reportRequestInformationDialog.open();
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-open-in-new")]), _vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.damage.askImages")) + " ")], 1), _c('v-btn', {
          attrs: {
            "elevation": "0"
          },
          on: {
            "click": function click($event) {
              _vm.isImageUploadDialogOpen = true;
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s(_vm.$t("timeLine.ActivityTimeLineItemImage.dialogTitle")) + " ")], 1)], 1)];
      },
      proxy: true
    }])
  }) : _c('vue-picture-swipe', {
    attrs: {
      "items": _vm.mapToImage,
      "options": {
        shareEl: false,
        rotationOn: true,
        history: false
      }
    }
  })], 1), _c('report-request-information-dialog', {
    ref: "reportRequestInformationDialog",
    attrs: {
      "report": _vm.report
    }
  }), _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.$t("timeLine.ActivityTimeLineItemImage.dialogTitle"),
      "isDialogActive": _vm.isImageUploadDialogOpen,
      "rightText": _vm.rightText,
      "hideLeft": true
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isImageUploadDialogOpen = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isImageUploadDialogOpen = $event;
      },
      "rightClick": _vm.next,
      "close": _vm.closeImageUploadDialog
    }
  }, [_c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isShowImagePreviewDialog,
      "title": _vm.$t('components.template.dialog.preview.preview'),
      "rightText": _vm.$t('ok'),
      "hideLeft": true
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isShowImagePreviewDialog = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isShowImagePreviewDialog = $event;
      },
      "rightClick": _vm.closeImagePreview,
      "close": _vm.closeImagePreview
    }
  }, [_c('v-img', {
    staticClass: "align-end ma-auto",
    style: "max-height: calc(100vh - ".concat(_vm.$vuetify.breakpoint.smAndDown ? '225px' : '300px', ");"),
    attrs: {
      "contain": "",
      "src": _vm.imagePreview
    }
  })], 1), _c('v-window', {
    model: {
      value: _vm.window,
      callback: function callback($$v) {
        _vm.window = $$v;
      },
      expression: "window"
    }
  }, [_c('v-window-item', {
    attrs: {
      "value": _vm.ImageUploadEnum.DROP
    }
  }, [_c('drop-area-multi', {
    attrs: {
      "files": _vm.files,
      "loading": _vm.isImageUploadLoading,
      "text": _vm.$t('timeLine.ActivityTimeLineItemImage.dialogTitle'),
      "dragoverText": _vm.$t('timeLine.ActivityTimeLineItemImage.dialogTitle')
    },
    on: {
      "update:files": function updateFiles($event) {
        _vm.files = $event;
      },
      "dropped": _vm.prepareImageUpload
    }
  })], 1), _c('v-window-item', {
    attrs: {
      "value": _vm.ImageUploadEnum.REVIEW
    }
  }, [_c('v-virtual-scroll', {
    attrs: {
      "items": _vm.images,
      "item-height": 64,
      "height": "475"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref12) {
        var index = _ref12.index,
            item = _ref12.item;
        return [_c('v-list-item', {
          key: index,
          staticClass: "px-0"
        }, [_c('v-list-item-avatar', {
          attrs: {
            "tile": ""
          },
          on: {
            "click": function click($event) {
              return _vm.showImagePreview(item);
            }
          }
        }, [_c('v-img', {
          key: 'image' + index,
          attrs: {
            "src": item.imageUrl,
            "max-height": "50",
            "max-width": "50"
          }
        })], 1), _c('v-list-item-content', {
          staticClass: "pr-4"
        }, [_c('v-list-item-title', [_c('v-text-field', {
          attrs: {
            "dense": "",
            "single-line": "",
            "hide-details": "",
            "disabled": item.isUploaded || item.isLoading,
            "loading": item.isLoading,
            "label": "Name"
          },
          model: {
            value: item.file.name,
            callback: function callback($$v) {
              _vm.$set(item.file, "name", $$v);
            },
            expression: "item.file.name"
          }
        })], 1), _c('v-list-item-subtitle', [_c('v-autocomplete', {
          attrs: {
            "items": Object.values(_vm.ReportImageType),
            "dense": "",
            "hide-details": ""
          },
          scopedSlots: _vm._u([{
            key: "item",
            fn: function fn(_ref13) {
              var item = _ref13.item;
              return [_vm._v(" " + _vm._s(_vm.$t("timeLine.PartnerReportDetailImageTimeLineElement.imageTypes.".concat(item))) + " ")];
            }
          }, {
            key: "selection",
            fn: function fn(_ref14) {
              var item = _ref14.item;
              return [_vm._v(" " + _vm._s(_vm.$t("timeLine.PartnerReportDetailImageTimeLineElement.imageTypes.".concat(item))) + " ")];
            }
          }], null, true),
          model: {
            value: item.type,
            callback: function callback($$v) {
              _vm.$set(item, "type", $$v);
            },
            expression: "item.type"
          }
        })], 1)], 1), item.isUploaded ? _c('v-list-item-action', [_c('span', [_vm._v(" " + _vm._s(_vm.$t("components.thg.thgBillingSelectionItemPdfResult.uploaded")) + " "), _c('v-icon', {
          attrs: {
            "small": "",
            "color": "success"
          }
        }, [_vm._v(" mdi-check ")])], 1)]) : _vm._e(), item.isLoading && !item.isUploaded ? _c('v-list-item-action', [_c('v-progress-circular', {
          attrs: {
            "indeterminate": "",
            "size": 20,
            "width": 3
          }
        })], 1) : _vm._e(), !item.isLoading && !item.isUploaded ? _c('v-list-item-action', [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref15) {
              var on = _ref15.on,
                  attrs = _ref15.attrs;
              return [_c('v-icon', _vm._g(_vm._b({
                staticClass: "mr-2",
                attrs: {
                  "small": "",
                  "tabindex": "-1"
                },
                on: {
                  "click": function click($event) {
                    return _vm.popImage(index);
                  }
                }
              }, 'v-icon', attrs, false), on), [_vm._v(" mdi-delete ")])];
            }
          }], null, true)
        }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t("remove")) + " ")])])], 1) : _vm._e()], 1)];
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)], 1), _c('v-divider'), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("report.witness.title")) + " "), _c('v-spacer'), _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-plus"
    },
    on: {
      "click": _vm.startWitness
    }
  })], 1), _vm.persons && _vm.persons.length > 0 ? _c('v-card-text', [_c('v-row', _vm._l(_vm.persons, function (person, index) {
    return _c('v-col', {
      key: 'person' + index,
      attrs: {
        "cols": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-card', {
      attrs: {
        "flat": "",
        "outlined": "",
        "color": _vm.$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4',
        "loading": _vm.isWitnessLoading
      }
    }, [_c('v-card-title', [_vm._v(" " + _vm._s(person.firstName) + " " + _vm._s(person.lastName) + " "), _c('v-spacer'), _c('m-icon-button', {
      attrs: {
        "icon": "mdi-trash-can",
        "loading": _vm.isWitnessLoading
      },
      on: {
        "click": function click($event) {
          return _vm.removeWitness(index);
        }
      }
    }), _c('m-icon-button', {
      on: {
        "click": function click($event) {
          return _vm.startWitness(index);
        }
      }
    })], 1), _c('v-card-subtitle', [_vm._v(" " + _vm._s(_vm.$t("report.witness.roles.".concat(person.role))) + " "), person.numberplate ? _c('v-chip', {
      staticClass: "mx-1",
      attrs: {
        "small": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "small": "",
        "left": ""
      }
    }, [_vm._v("mdi-car")]), _vm._v(" " + _vm._s(person.numberplate) + " ")], 1) : _vm._e(), _vm._l(person.insurances || [], function (insurance, insuranceIndex) {
      return _c('v-chip', {
        key: 'witness' + index + 'insurance' + insuranceIndex,
        staticClass: "mx-1",
        attrs: {
          "small": ""
        }
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "left": ""
        }
      }, [_vm._v("mdi-shield-car")]), _vm._v(" " + _vm._s(insurance.name) + " " + _vm._s(insurance.number) + " ")], 1);
    }), person.isInjured ? _c('v-chip', {
      staticClass: "mx-1",
      attrs: {
        "small": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "small": "",
        "left": ""
      }
    }, [_vm._v("mdi-ambulance")]), _vm._v(" " + _vm._s(_vm.$t("report.witness.isInjured")) + " ")], 1) : _vm._e(), person.imageIds && person.imageIds.length > 0 ? _c('v-chip', {
      staticClass: "mx-1",
      attrs: {
        "small": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "small": "",
        "left": ""
      }
    }, [_vm._v("mdi-paperclip")]), _c('span', [_vm._v(" " + _vm._s(_vm.$t("common.nouns.attachments")) + " ")]), _c('span', [_vm._v("( " + _vm._s(person.imageIds.length) + " )")])], 1) : _vm._e()], 2), _c('v-card-text', [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "6"
      }
    }, [_c('m-text-field', {
      attrs: {
        "label": _vm.$t('common.nouns.email'),
        "hide-details": "",
        "readonly": ""
      },
      model: {
        value: person.contact.email,
        callback: function callback($$v) {
          _vm.$set(person.contact, "email", $$v);
        },
        expression: "person.contact.email"
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "6"
      }
    }, [_c('m-text-field', {
      attrs: {
        "label": _vm.$t('common.nouns.phone'),
        "hide-details": "",
        "readonly": ""
      },
      model: {
        value: person.contact.phone,
        callback: function callback($$v) {
          _vm.$set(person.contact, "phone", $$v);
        },
        expression: "person.contact.phone"
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('v-textarea', {
      attrs: {
        "label": _vm.$t('common.nouns.note'),
        "hide-details": "",
        "rows": "2",
        "readonly": ""
      },
      model: {
        value: person.note,
        callback: function callback($$v) {
          _vm.$set(person, "note", $$v);
        },
        expression: "person.note"
      }
    })], 1)], 1)], 1), _c('v-card-actions')], 1)], 1);
  }), 1)], 1) : _c('v-card-text', [_c('m-no-content', {
    attrs: {
      "icon": "mdi-account",
      "text": _vm.$t('report.witness.noAccidentParticipants')
    }
  })], 1), _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.$t('report.witness.title'),
      "isDialogActive": _vm.isWitnessDialogOpen,
      "rightDisabled": !_vm.isWitnessValid,
      "loading": _vm.isWitnessLoading,
      "hideLeft": true
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isWitnessDialogOpen = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isWitnessDialogOpen = $event;
      },
      "rightClick": _vm.addWitness,
      "hover:action": function hoverAction($event) {
        return _vm.$refs.witnessForm.validate();
      }
    }
  }, [_c('v-form', {
    ref: "witnessForm",
    model: {
      value: _vm.isWitnessValid,
      callback: function callback($$v) {
        _vm.isWitnessValid = $$v;
      },
      expression: "isWitnessValid"
    }
  }, [_c('witness-form', {
    model: {
      value: _vm.witness,
      callback: function callback($$v) {
        _vm.witness = $$v;
      },
      expression: "witness"
    }
  })], 1)], 1)], 1)], 1), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _c('v-col', {
    staticClass: "order-md-first",
    attrs: {
      "cols": "12",
      "md": "5",
      "lg": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("timeLine.PartnerAccidentDetailsTimeLineElement.title")) + " "), _c('v-spacer'), _c('m-icon-button', {
    on: {
      "click": _vm.startEditAccident
    }
  })], 1), _c('v-card-text', [_c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_vm.report.accidentDetails ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('m-text-field', {
    attrs: {
      "type": "datetime-local",
      "label": _vm.$t('report.accidentDetails.date'),
      "readonly": "",
      "hide-details": "",
      "append-icon": ''
    },
    model: {
      value: _vm.report.accidentDetails.dateFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.report.accidentDetails, "dateFormable", $$v);
      },
      expression: "report.accidentDetails.dateFormable"
    }
  })], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "12",
      "lg": "6"
    }
  }, [_c('m-select', {
    attrs: {
      "label": _vm.$t('objects.report.isUnderInfluence'),
      "readonly": _vm.readonly,
      "items": [true, false],
      "append-icon": _vm.readonly ? '' : undefined,
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref16) {
        var item = _ref16.item;
        return [_c('v-chip', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("report.accidentDetails.location.".concat(item))) + " ")])];
      }
    }, {
      key: "item",
      fn: function fn(_ref17) {
        var item = _ref17.item;
        return [_vm._v(" " + _vm._s(_vm.$t("report.accidentDetails.location.".concat(item))) + " ")];
      }
    }]),
    model: {
      value: _vm.report.isUnderInfluence,
      callback: function callback($$v) {
        _vm.$set(_vm.report, "isUnderInfluence", $$v);
      },
      expression: "report.isUnderInfluence"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "12",
      "lg": "6"
    }
  }, [_c('m-select', {
    attrs: {
      "label": _vm.$t('objects.report.tripType'),
      "readonly": _vm.readonly,
      "items": _vm.tripTypeItems,
      "append-icon": _vm.readonly ? '' : undefined,
      "hide-details": ""
    },
    model: {
      value: _vm.report.tripType,
      callback: function callback($$v) {
        _vm.$set(_vm.report, "tripType", $$v);
      },
      expression: "report.tripType"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "12",
      "lg": "6"
    }
  }, [_c('m-select', {
    attrs: {
      "label": _vm.$t('report.tripDetails.isValidDriversLicense'),
      "readonly": _vm.readonly,
      "items": [true, false],
      "append-icon": _vm.readonly ? '' : undefined,
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref18) {
        var item = _ref18.item;
        return [_c('v-chip', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("report.accidentDetails.location.".concat(item))) + " ")])];
      }
    }, {
      key: "item",
      fn: function fn(_ref19) {
        var item = _ref19.item;
        return [_vm._v(" " + _vm._s(_vm.$t("report.accidentDetails.location.".concat(item))) + " ")];
      }
    }]),
    model: {
      value: _vm.report.isValidDriversLicense,
      callback: function callback($$v) {
        _vm.$set(_vm.report, "isValidDriversLicense", $$v);
      },
      expression: "report.isValidDriversLicense"
    }
  })], 1), _vm.report.accidentDetails ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "lg": "6"
    }
  }, [_c('m-select', {
    attrs: {
      "items": Object.values(_vm.ReportRoleEnum),
      "label": _vm.$t('report.accidentDetails.role.label'),
      "hide-details": "",
      "readonly": "",
      "append-icon": ''
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref20) {
        var item = _ref20.item;
        return [_vm._v(" " + _vm._s(_vm.$t("report.witness.roles.".concat(item))) + " ")];
      }
    }, {
      key: "item",
      fn: function fn(_ref21) {
        var item = _ref21.item;
        return [_vm._v(" " + _vm._s(_vm.$t("report.witness.roles.".concat(item))) + " ")];
      }
    }], null, false, 830363900),
    model: {
      value: _vm.report.accidentDetails.role,
      callback: function callback($$v) {
        _vm.$set(_vm.report.accidentDetails, "role", $$v);
      },
      expression: "report.accidentDetails.role"
    }
  })], 1) : _vm._e(), _vm.report.mileage ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "lg": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.report.mileage'),
      "readonly": _vm.readonly,
      "prefix": "km",
      "hide-details": ""
    },
    model: {
      value: _vm.report.mileage,
      callback: function callback($$v) {
        _vm.$set(_vm.report, "mileage", $$v);
      },
      expression: "report.mileage"
    }
  })], 1) : _vm._e()], 1), _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_vm.report.accidentDetails ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('partner-report-map-address', {
    model: {
      value: _vm.report.accidentDetails.address,
      callback: function callback($$v) {
        _vm.$set(_vm.report.accidentDetails, "address", $$v);
      },
      expression: "report.accidentDetails.address"
    }
  }), _vm.report.accidentDetails.comment ? _c('v-textarea', {
    attrs: {
      "rows": "3",
      "label": _vm.$t('components.partner.PartnerReportDetail.PartnerReportUpdateReportDialog.accidentDetails.comment')
    },
    model: {
      value: _vm.report.accidentDetails.comment,
      callback: function callback($$v) {
        _vm.$set(_vm.report.accidentDetails, "comment", $$v);
      },
      expression: "report.accidentDetails.comment"
    }
  }) : _vm._e()], 1) : _c('v-col', [_c('m-no-content', {
    attrs: {
      "icon": "mdi-map-marker-question",
      "text": "Keine Unfallort hinterlegt."
    }
  })], 1), _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.$t('timeLine.PartnerAccidentDetailsTimeLineElement.title'),
      "isDialogActive": _vm.isAccidentDialogOpen,
      "rightDisabled": !_vm.isAccidentValid,
      "loading": _vm.isAccidentLoading,
      "hideLeft": true
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isAccidentDialogOpen = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isAccidentDialogOpen = $event;
      },
      "rightClick": _vm.updateAccident
    }
  }, [_c('v-form', {
    model: {
      value: _vm.isAccidentValid,
      callback: function callback($$v) {
        _vm.isAccidentValid = $$v;
      },
      expression: "isAccidentValid"
    }
  }, [_c('accident-form', {
    model: {
      value: _vm.accident,
      callback: function callback($$v) {
        _vm.accident = $$v;
      },
      expression: "accident"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('v-divider'), _vm.isLoading ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-skeleton-loader', {
    attrs: {
      "type": "card-heading, divider, list-item-two-line, list-item-two-line, list-item-two-line"
    }
  })], 1) : _vm._e(), _vm.showTowing ? _c('partner-report-towing-card', {
    attrs: {
      "report": _vm.report
    }
  }) : _vm._e(), _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.$t("components.PartnerReportDetail.damage.references"),
      "isDialogActive": _vm.isReferencesDialogOpen,
      "rightDisabled": !_vm.isReferencesValid,
      "rightLoading": _vm.isReferencesLoading,
      "hideLeft": true
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isReferencesDialogOpen = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isReferencesDialogOpen = $event;
      },
      "rightClick": _vm.updateReferences
    }
  }, [_c('v-form', {
    model: {
      value: _vm.isReferencesValid,
      callback: function callback($$v) {
        _vm.isReferencesValid = $$v;
      },
      expression: "isReferencesValid"
    }
  }, [_c('references-form', {
    model: {
      value: _vm.references,
      callback: function callback($$v) {
        _vm.references = $$v;
      },
      expression: "references"
    }
  })], 1)], 1), _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.$t("edit"),
      "isDialogActive": _vm.isEditDamageDialogOpen,
      "rightDisabled": !_vm.isDamageValid,
      "rightLoading": _vm.isDamageLoading,
      "hideLeft": true,
      "width": 960
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isEditDamageDialogOpen = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isEditDamageDialogOpen = $event;
      },
      "rightClick": _vm.updateDamage
    }
  }, [_vm.damage ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('v-form', {
    model: {
      value: _vm.isDamageValid,
      callback: function callback($$v) {
        _vm.isDamageValid = $$v;
      },
      expression: "isDamageValid"
    }
  }, [_c('damage-form', {
    model: {
      value: _vm.damage,
      callback: function callback($$v) {
        _vm.damage = $$v;
      },
      expression: "damage"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c('v-subheader', {
    staticClass: "px-0"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.partner.PartnerReportDetailInfoCard.damageLocator.title")) + " ")]), _c('div', {
    staticClass: "mx-auto d-flex justify-center align-center",
    staticStyle: {
      "max-width": "300px",
      "height": "calc(100% - 48px)"
    }
  }, [_c('damage-locator-combined', {
    key: 'locator' + _vm.damageKey,
    ref: "DamageLocator",
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "isEdit": true,
      "reportType": _vm.report.reportType,
      "damage-locations": _vm.damage.area,
      "data-test-damage-locator-combined": ""
    },
    on: {
      "update:damageLocations": function updateDamageLocations($event) {
        return _vm.$set(_vm.damage, "area", $event);
      },
      "update:damage-locations": function updateDamageLocations($event) {
        return _vm.$set(_vm.damage, "area", $event);
      },
      "svgClicked": _vm.svgClicked
    }
  })], 1)], 1), _vm.report.attachment && _vm.report.attachment.length ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('v-subheader', {
    staticClass: "mt-4"
  }, [_vm._v(_vm._s(_vm.$t("common.nouns.images")))]), _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, _vm._l(_vm.report.attachment, function (img, idx) {
    return _c('v-list-item', {
      key: img.id
    }, [_c('v-list-item-avatar', {
      on: {
        "click": function click($event) {
          _vm.$refs.pictureSwipeEdit && _vm.$refs.pictureSwipeEdit.open(idx);
        }
      }
    }, [_c('vue-picture-swipe', {
      ref: "pictureSwipeEdit",
      refInFor: true,
      staticClass: "mx-2 mb-2",
      attrs: {
        "items": [{
          src: img.url,
          thumbnail: img.url,
          w: 0,
          h: 0,
          title: _vm.$t("timeLine.PartnerReportDetailImageTimeLineElement.imageTypes.".concat(img.type))
        }],
        "options": {
          shareEl: false,
          rotationOn: true,
          showAnimationDuration: 0,
          hideAnimationDuration: 0
        }
      }
    })], 1), _c('v-list-item-content', [_c('v-list-item-title', {
      class: {
        'text--disabled': _vm.pendingRemoveImageIds.includes(img.id),
        'text-decoration-line-through': _vm.pendingRemoveImageIds.includes(img.id)
      }
    }, [_vm._v(" " + _vm._s(img.name) + " ")]), img.type ? _c('v-list-item-subtitle', {
      class: {
        'text--disabled': _vm.pendingRemoveImageIds.includes(img.id),
        'text-decoration-line-through': _vm.pendingRemoveImageIds.includes(img.id)
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("timeLine.PartnerReportDetailImageTimeLineElement.imageTypes.".concat(img.type))) + " ")]) : _vm._e()], 1), _vm.canDeleteImage ? _c('v-list-item-action', [_c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref22) {
          var on = _ref22.on,
              attrs = _ref22.attrs;
          return [!_vm.pendingRemoveImageIds.includes(img.id) ? _c('v-icon', _vm._g(_vm._b({
            attrs: {
              "small": ""
            },
            on: {
              "click": function click($event) {
                return _vm.markImageForRemoval(img.id);
              }
            }
          }, 'v-icon', attrs, false), on), [_vm._v(" mdi-delete ")]) : _c('v-icon', _vm._g(_vm._b({
            attrs: {
              "small": "",
              "color": "grey"
            },
            on: {
              "click": function click($event) {
                return _vm.undoRemoveImage(img.id);
              }
            }
          }, 'v-icon', attrs, false), on), [_vm._v(" mdi-undo ")])];
        }
      }], null, true)
    }, [_c('span', [_vm._v(_vm._s(_vm.pendingRemoveImageIds.includes(img.id) ? _vm.$t("undo") : _vm.$t("remove")))])])], 1) : _vm._e()], 1);
  }), 1)], 1)], 1) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1), _c('v-divider')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }